import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const gFlexCss = ".g__flex{box-sizing:border-box}.g__flex .g__button__host{display:flex}";
const GFlexStyle0 = gFlexCss;

const GFlex = /*@__PURE__*/ proxyCustomElement(class GFlex extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.alignContent = undefined;
        this.alignItems = undefined;
        this.alignSelf = undefined;
        this.display = 'flex';
        this.flex = undefined;
        this.flexBasis = undefined;
        this.flexDirection = undefined;
        this.flexGrow = undefined;
        this.flexShrink = undefined;
        this.flexWrap = undefined;
        this.height = undefined;
        this.justifyContent = undefined;
        this.margin = undefined;
        this.marginBottom = undefined;
        this.marginLeft = undefined;
        this.marginRight = undefined;
        this.marginTop = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.minHeight = undefined;
        this.minWidth = undefined;
        this.order = undefined;
        this.padding = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.paddingTop = undefined;
        this.width = undefined;
        this.dataTestId = undefined;
    }
    render() {
        var _a;
        const baseClass = 'g__flex';
        const flexStyles = {
            alignContent: this.alignContent,
            alignSelf: this.alignSelf,
            alignItems: this.alignItems,
            display: this.display,
            flex: this.flex,
            flexBasis: this.flexBasis,
            flexDirection: this.flexDirection,
            flexGrow: this.flexGrow,
            flexShrink: this.flexShrink,
            flexWrap: this.flexWrap,
            height: this.height,
            justifyContent: this.justifyContent,
            margin: this.margin,
            marginBottom: this.marginBottom,
            marginLeft: this.marginLeft,
            marginRight: this.marginRight,
            marginTop: this.marginTop,
            maxHeight: this.maxHeight,
            maxWidth: this.maxWidth,
            minHeight: this.minHeight,
            minWidth: this.minWidth,
            order: this.order,
            padding: this.padding,
            paddingBottom: this.paddingBottom,
            paddingLeft: this.paddingLeft,
            paddingRight: this.paddingRight,
            paddingTop: this.paddingTop,
            width: this.width,
        };
        return (h(Host, { key: 'e33a3a9db47d92ad4931e89dcb53961753038bb4', "data-testid": ((_a = this.dataTestId) === null || _a === void 0 ? void 0 : _a.host) || baseClass, style: flexStyles, class: "g__flex" }, h("slot", { key: 'dd4e0cbf6e25d90b9e82923d8e77e2e0389dcb10' })));
    }
    static get style() { return GFlexStyle0; }
}, [4, "g-flex", {
        "alignContent": [1, "align-content"],
        "alignItems": [1, "align-items"],
        "alignSelf": [1, "align-self"],
        "display": [1],
        "flex": [1],
        "flexBasis": [1, "flex-basis"],
        "flexDirection": [1, "flex-direction"],
        "flexGrow": [1, "flex-grow"],
        "flexShrink": [1, "flex-shrink"],
        "flexWrap": [1, "flex-wrap"],
        "height": [1],
        "justifyContent": [1, "justify-content"],
        "margin": [1],
        "marginBottom": [1, "margin-bottom"],
        "marginLeft": [1, "margin-left"],
        "marginRight": [1, "margin-right"],
        "marginTop": [1, "margin-top"],
        "maxHeight": [1, "max-height"],
        "maxWidth": [1, "max-width"],
        "minHeight": [1, "min-height"],
        "minWidth": [1, "min-width"],
        "order": [1],
        "padding": [1],
        "paddingBottom": [1, "padding-bottom"],
        "paddingLeft": [1, "padding-left"],
        "paddingRight": [1, "padding-right"],
        "paddingTop": [1, "padding-top"],
        "width": [1],
        "dataTestId": [16]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["g-flex"];
    components.forEach(tagName => { switch (tagName) {
        case "g-flex":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, GFlex);
            }
            break;
    } });
}

export { GFlex as G, defineCustomElement as d };

//# sourceMappingURL=g-flex2.js.map